import { Fragment, useMemo } from 'react'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import ReactTooltip from 'react-tooltip'
import { StickyHeader, FiltersActivity } from '../../components'
import messages from '../../messages'
import {
  SearchTypesSelector,
  SearchTypesMobileSelector,
  ActivityWrapper,
  BackListViewComponent,
  MobileFilters,
  SortingFilters,
  ActivitesPageTitle,
  SearchMap,
} from '../../components/search'
import { setNumberOfTrips } from '../../actions/search-actions'
import { TemporaryBanner } from '../../components/popups/TemporaryBanner'
import {
  searchFiltersHook,
  searchOnInitHook,
} from '../../components/search/hooks'

import PropTypes from 'prop-types'

import {
  filtersKeys,
  filtersToClean,
  SORT_BY,
  GROUP_BY,
} from './../searchData'
import usePageObserver from '../../components/search/hooks/usePageObserver'

function ActivitesSearch({
  searchFilters,
  model,
  pk,
  point,
  activityType,
  selectedCurrency,
  isNearBy,
  title,
  inTitle,
  numberOfTrips,
  locationCoordinates,
  isWidget,
  filters,
  trustpilotLocale,
  setNumberOfTrips,
  countryCode,
}) {
  const intl = useIntl()
  const activityAPIUrl = useMemo(
    () => model ? `search/autosuggest/${model.toLowerCase()}/${pk}/dive-centers/` : '',
    [model, pk],
  )

  usePageObserver(activityType)
  const {
    transformedFilters,
    filtersCount,
    updateParams,
    updateOrdering,
    triggerApi,
    clearSelectedFilters,
    clearDates,
    showListView,
    handleGroupSelect,
  } = searchFiltersHook(filtersKeys, filtersToClean, activityType)
  searchOnInitHook(filtersKeys, 'activites', activityType)
  const isMapView = useMemo(() => transformedFilters.view === 'map', [
    transformedFilters.view,
  ])

  return (
    <div className='search-page-la search-page-dr'>
      {isMapView && <BackListViewComponent onClose={showListView} />}
      <StickyHeader typeOfSearch={activityType} locationTitle={title} />
      <ReactTooltip type='dark' effect='solid' id='global' />
      <div className={`search-wrapper ${isMapView ? 'full-width' : ''}`}>
        <div className='main-content'>
          <div className='results-head results-sort-wrapper display-flex content-s-b items-center'>
            <ActivitesPageTitle
              activityType={activityType}
              inTitle={inTitle}
              isNearBy={isNearBy}
              selectedDate={transformedFilters.date}
              numberOfItems={numberOfTrips}
            />
            <div className='shop-types-search-page'>
              <SearchTypesSelector
                activePage={window.typesData && window.typesData.activePage}
                isMapView={isMapView}
                nearByPoint={transformedFilters.point}
              />
              <SearchTypesMobileSelector
                activePage={window.typesData && window.typesData.activePage}
                nearByPoint={transformedFilters.point}
              />
            </div>
            <SortingFilters
              updateOrdering={updateOrdering}
              orderingValue={transformedFilters.ordering}
              sortByItems={SORT_BY}
              viewByItems={GROUP_BY}
              viewByValue={transformedFilters.view}
              updateViewBy={handleGroupSelect}
            />
            {isNearBy && !isMapView && (
              <TemporaryBanner
                id='use_map_tip'
                text={intl.formatMessage(messages.use_map_tip, {
                  strong: (str) => <strong>{str}</strong>,
                })}
              />
            )}
          </div>
          <FiltersActivity
            model={model}
            pk={pk}
            triggerApi={triggerApi}
            isWidget={isWidget}
            selectedFilters={searchFilters}
            items={filters}
            title={title}
            updateParams={updateParams}
            clearDates={clearDates}
            clearSelectedFilters={clearSelectedFilters}
            trustpilotLocale={trustpilotLocale}
            filtersCount={filtersCount}
            selectedCurrency={selectedCurrency}
            activityType={activityType}
            activityUrl={activityAPIUrl}
          />
          <div className='result-list'>
            {isMapView ? (
              <SearchMap
                searchType={activityType}
                isActivityEndpoint
                sortKey='pk'
                selectedParams={transformedFilters}
                showListView={showListView}
                initLocation={locationCoordinates}
                countryCode={countryCode}
              />
            ) : (
              <Fragment>
                <MobileFilters
                  filtersCount={filtersCount}
                  updateParams={updateParams}
                  handleSortSelect={updateOrdering}
                  sortOptions={SORT_BY}
                  selectedSorting={transformedFilters.ordering}
                />
                <ActivityWrapper
                  setNumberOfItems={setNumberOfTrips}
                  selectedParams={transformedFilters}
                  getNewData={triggerApi}
                  model={model}
                  numberOfTrips={numberOfTrips}
                  pk={pk}
                  gPlacePoint={point}
                  point={transformedFilters.point}
                  distance={transformedFilters.distance}
                  activityType={activityType}
                  selectedCurrency={selectedCurrency}
                  isDateView={transformedFilters.view === 'date'}
                />
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ({
  isNearBy,
  searchFilters,
  selectedCurrency,
  numberOfTrips,
}) => ({
  isNearBy,
  searchFilters,
  selectedCurrency,
  numberOfTrips,
})

export default connect(mapStateToProps, { setNumberOfTrips })(ActivitesSearch)

ActivitesSearch.propTypes = {
  searchFilters: PropTypes.object,
  model: PropTypes.string,
  pk: PropTypes.string,
  point: PropTypes.object,
  activityType: PropTypes.string,
  selectedCurrency: PropTypes.string,
  isNearBy: PropTypes.bool,
  title: PropTypes.string,
  inTitle: PropTypes.string,
  numberOfTrips: PropTypes.number,
  locationCoordinates: PropTypes.object,
  isWidget: PropTypes.bool,
  filters: PropTypes.array,
  trustpilotLocale: PropTypes.string,
  setNumberOfTrips: PropTypes.func,
  countryCode: PropTypes.string,
}
